export const ACTIVITY_ANALYZE_SCOPE = 'activityAnalyze';
